import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions } from 'core/query/type'
import {
  TGetCmsCommunityLinksParams,
  TGetCmsCommunityLinksResponse,
  getCmsCommunityLinks,
} from 'core/service/yapi/hk-web/CmsCommunity/api'
// 官方社群相关接口
// 查询帮助中心链接列表
export const useGetCmsCommunityLinksQuery = (
  params?: TGetCmsCommunityLinksParams,
  options?: TUseQueryOptions<TGetCmsCommunityLinksResponse>
) => {
  return useQuery({
    ...options,
    queryKey: ['CmsCommunity', 'CmsCommunityLinks', 'GET', ...Object.values(params || {})],
    queryFn: () => getCmsCommunityLinks(params),
  })
}
